// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__qm9Vy","menuTrigger":"TopMenu_menuTrigger__Bf+D5","rightNav":"TopMenu_rightNav__LbgcU","altNav":"TopMenu_altNav__V+MyW","closed":"TopMenu_closed__ANEIt"};